// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".close-btn[data-v-6a85855f]{cursor:pointer;color:#999;font-size:16px}.close-btn[data-v-6a85855f]:hover{color:#f5222d}", ""]);
// Exports
module.exports = exports;
